import { useEffect, useState } from "react";
import "./verifyIdentityInfo.scss";
import MainTitle from "../command/mainTitle/mainTitle";
import { Link, useNavigate } from "react-router-dom";
import Button from "../command/Button/Button";
import FixFooterButton from "../command/fixFooterButton/fixFooterButton";
import VerifyIdentityModal from "./verifyIdentityModal";
import PostRentalIDModal from "./PostRentalIDModal";
import { customerVerificationClient } from "../../data/verify-info";
import { getAuthCredentials, getIdvBypass } from "../../utils/auth-utils";
import {
  Effect,
  ScanPhotoId,
  TakePhoto,
} from "../../assets/svgIcon/customIcon";
import { ChevronRight } from "react-feather";
import { VerifyIdentityImg } from "../../assets/svgImages/svgImages";
import { useTranslation } from "react-i18next";
import { productDetailsClient } from "../../data/product-details";
import { toast } from "react-toastify";

const VerifyIdentityInfo = () => {
  const navigate = useNavigate();
  const [verifyIdentityShow, setVerifyIdentityShow] = useState(false);
  const { t } = useTranslation();
  const { bypassIDV, maximumOrderValue } = getIdvBypass();
  const [showIdvBypassLink, setShowIdvBypassLink] = useState(false);
  const [showPostRentalIdLink, setShowPostRentalIdLink] = useState(false);
  const [showPostRentalModal, setShowPostRentalModal] = useState(false);
  const [retailerStoreName, setRetailerStoreName] = useState<string>("");
  const [quote, setQuote] = useState<any>();
  const { customerUuid, quoteId } = getAuthCredentials();

  useEffect(() => {
    if (quoteId) {
      productDetailsClient
        .getProductDetailsList({ quoteUuid: quoteId })
        .then((data: any) => {
          setQuote(data.quote);

          if (bypassIDV) {
            const showLink = Number(data.quote?.productRetailPrice) <= Number(maximumOrderValue ?? 0);
            setShowIdvBypassLink(showLink)
          }
          if (data?.allowIDVerificationPostRental) {
            setShowPostRentalIdLink(true);
            setRetailerStoreName(data.storeDetails?.storeName ?? "");
          }
        })
        .catch((error: any) => {
          toast.error(error?.message);
        });
    }
  }, [bypassIDV, maximumOrderValue]);

  const customerKYC = () => {
    localStorage.removeItem("journeyID");
    customerVerificationClient
      .checkCustomerKYC({ customerUuid: customerUuid, quoteUuid: quoteId })
      .then((data: any) => {
        if (data) {
          localStorage.setItem("journeyID", data.journeyID);
          navigate("/kyc-verify", { state: { kycLink: data.URL } });
        }
      });
  };

  const goToInformationCapture = () => {
    navigate("/information-capture");
  };

  const handleNoIdClick = (e: React.MouseEvent) => {
    e.preventDefault();
    localStorage.removeItem("journeyID");
    goToInformationCapture();
  };

  return (
    <>
      <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-md-12 ">
              <div className="effect-add-section">
                <Effect className="effect-img" />
                <div className="verify-identity-box">
                  <div className="row">
                    <div className="col-md-12 order-0">
                      <MainTitle mainText={t("verify-your-identity")} />
                    </div>
                    <div className="col-xl-6 col-lg-6 order-xl-1 order-lg-1 order-2">
                      <div className="verify-identity-info-box">
                        <h3 className="verify-sub-title">
                          {t("verify-your-identity-sub-title")}.
                        </h3>
                        <p className="verify-details">
                          {t("verify-your-identity-details")}.
                        </p>
                        <div className="verify-identity-steps">
                          <ScanPhotoId />
                          <div className="verify-steps-info">
                            <h4>{t("step-1")}</h4>
                            <p>
                              <Link
                                to={"#"}
                                onClick={() => setVerifyIdentityShow(true)}
                              >
                                {t("click-here")}
                              </Link>{" "}
                              {t("see-full-photo-list")}
                            </p>
                            <ul>
                              <li>
                                <ChevronRight size={16} color="#000000" />{" "}
                                {t("scan-photo-id-points-one")}
                              </li>
                              <li>
                                <ChevronRight size={16} color="#000000" />{" "}
                                {t("scan-photo-id-points-two")}
                              </li>
                              <li>
                                <ChevronRight size={16} color="#000000" />{" "}
                                {t("scan-photo-id-points-three")}
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="verify-identity-steps m-0">
                          <TakePhoto />
                          <div className="verify-steps-info mt-1">
                            <h4>{t("take-your-picture")}</h4>
                            <p>{t("take-your-picture-description")}.</p>
                          </div>
                        </div>
                        <div className="identity-note">
                          <img
                            className="img-fluid"
                            src="./images/cyber-security.svg"
                            alt="verify-identity-img"
                          />
                          <p>{t("verified-your-id-description")}</p>
                        </div>
                        <FixFooterButton>
                          <Button
                            btnText={t("step-1")}
                            onClick={() => customerKYC()}
                          />
                          {showIdvBypassLink && <Link to="#" className="no-id-link" onClick={handleNoIdClick}>
                            I don't have my ID right now
                          </Link>}
                          {(showPostRentalIdLink) && (
                            <>
                              <p className="or-divider">OR</p>
                              <Link
                                to="#"
                                className="no-id-link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowPostRentalModal(true);
                                }}
                              >
                                Verify my ID in person at {retailerStoreName} - bring your ID with you on the day of your rental
                              </Link>
                            </>

                          )}
                        </FixFooterButton>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 order-xl-2 order-lg-2 order-1">
                      <div className="verify-identity-main-img">
                        <img
                          className="img-fluid d-none d-lg-block"
                          src="./images/verify-identity-img-primary.png"
                          alt="verify-identity-img"
                        />
                        <VerifyIdentityImg className="img-fluid d-block d-lg-none" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Verify Identity Modal */}
      <VerifyIdentityModal
        show={verifyIdentityShow}
        verifyIdentityModalHide={() => setVerifyIdentityShow(false)}
      />
      <PostRentalIDModal
        show={showPostRentalModal}
        storeName={retailerStoreName}
        onContinue={goToInformationCapture}
        onHide={() => setShowPostRentalModal(false)}
      />
    </>
  );
};

export default VerifyIdentityInfo;
